export default __webpack_public_path__ + "static/846afadd78233b3c4d65933c5601f83c.jpeg";